export function formattedCurrentDate() {
  const date = new Date();
  const formattedDate = `${date.getFullYear()}-${date.getMonth() +
    1}-${date.getDate()}`;
  return formattedDate;
}



// WEBPACK FOOTER //
// ./src/utils/dateFormat.js